module.exports = __webpack_public_path__ + "img/CZ.cfe8be3b.svg";